import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.TRADE_SERVER_PREFIX}/post`
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    countPost: () => `${RESOURCE_ENDPOINT}/count-post`,
    getPostAnalytics: () => `${RESOURCE_ENDPOINT}/post-analytics`,
}

export default class PostApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        
        const url = endpoints.list();
        return  HttpService.get(url, params, headers);
    }

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    }

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }

    public countPost = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.countPost();
        return HttpService.get(url, params, headers);
    }

    public getPostAnalytics = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getPostAnalytics();
        return HttpService.get(url, params, headers);
    }
}


// status%3D1+AND+
// ((user_id%3D71+AND+post_type%3D%27FIBER_COTTON%27)+OR+
// (user_id%3D111+AND+post_type%3D%27FIBER_COTTON%27)+OR+
// (user_id%3D13+AND+post_type%3D%27TEXTILE%27)+OR+
// (user_id%3D10+AND+post_type%3D%27PORTFOLIO_DESIGN%27)+OR+
// (user_id%3D116+AND+post_type%3D%27YARN%27)+OR+
// (user_id%3D13+AND+post_type%3D%27PORTFOLIO_CONSULTANT%27))

// status%3D1+AND+
// ((user_id%3D71+AND+post_type%3D%27FIBER_COTTON%27)+OR+
// (user_id%3D111+AND+post_type%3D%27FIBER_COTTON%27)+OR+
// (user_id%3D13+AND+post_type%3D%27TEXTILE%27)+OR+
// (user_id%3D10+AND+post_type%3D%27PORTFOLIO_DESIGN%27)+OR+
// (user_id%3D116+AND+post_type%3D%27YARN%27))